import React from 'react';
import styled from 'styled-components';
import { Home, Layers, Send, Settings } from 'react-feather';

const TABS = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'accounts', label: 'Accounts', icon: Layers },
  { id: 'transfer', label: 'Transfer', icon: Send },
  { id: 'settings', label: 'Settings', icon: Settings },
];

const NavContainer = styled.nav`
  display: flex;
  background-color: ${p => p.theme.isDark ? 'rgba(31, 41, 55, 0.85)' : 'rgba(255, 255, 255, 0.85)'};
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-top: 1px solid ${p => p.theme.isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom, 20px);
  height: calc(80px + env(safe-area-inset-bottom, 20px));
  z-index: 9999;
  box-sizing: border-box;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.06);

  @media (min-width: 1024px) {
    display: none;
  }
`;

const TabButtonWrapper = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  background: none;
  border: none;
  cursor: pointer;
  height: 100%;
  padding: 8px 0 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  -webkit-tap-highlight-color: transparent;

  &:active {
    transform: scale(0.92);
  }
`;

const IconWrapper = styled.div`
  width: 56px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: ${p => p.$isActive ? (p.theme.isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.06)') : 'transparent'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 4px;
`;

const TabLabel = styled.span`
  font-size: 11px;
  font-weight: ${p => p.$isActive ? 700 : 500};
  color: ${p => p.$isActive ? p.theme.colors.text.primary : '#9ca3af'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.2px;
`;

const ActiveIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -16px;
  width: 32px;
  height: 3px;
  background-color: ${p => p.theme.isDark ? '#ffffff' : '#1f2937'};
  border-radius: 0 0 4px 4px;
  opacity: ${p => p.$isActive ? 1 : 0};
  transform: ${p => p.$isActive ? 'translateY(0)' : 'translateY(-4px)'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

const TabButton = ({ tab, isActive, onPress }) => {
  const Icon = tab.icon;

  return (
    <TabButtonWrapper
      onClick={() => onPress(tab.id)}
      aria-label={tab.label}
      aria-current={isActive ? 'page' : undefined}
      role="tab"
    >
      <ActiveIndicator $isActive={isActive} />
      <IconWrapper $isActive={isActive} aria-hidden="true">
        <Icon
          size={24}
          strokeWidth={isActive ? 2.5 : 2}
          style={{
            color: isActive ? 'inherit' : '#9ca3af',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        />
      </IconWrapper>
      <TabLabel $isActive={isActive} aria-hidden="true">
        {tab.label}
      </TabLabel>
    </TabButtonWrapper>
  );
};

const SmartBottomNav = ({ mode, activeTab, onTabPress }) => {
  return (
    <NavContainer aria-label="Bottom Navigation" role="tablist">
      {TABS.map((tab) => (
        <TabButton
          key={tab.id}
          tab={tab}
          isActive={activeTab === tab.id}
          onPress={onTabPress}
        />
      ))}
    </NavContainer>
  );
};

export default SmartBottomNav;
